<template>
  <div :class="{ 'light-description': lightColor }">
    <span v-if="version.status === TENDER_OFFER_VERSION_STATUSSES.draft">
      <span v-if="version && version.updated_at">
        <span>{{ $t('Edited') }}</span>
        <span v-if="!isDateLessThanWeekAgo(version.updated_at)">
          {{ $t('on') }}
        </span>
        <span>
          {{ getPrettyDate(version.updated_at) }}
        </span>
      </span>
    </span>
    <div v-else :class="{ 'flex-row': lightColor }">
      <div v-if="versionDate(version)">
        <span>{{ $t('Created') }} </span>
        <span v-if="!isDateLessThanWeekAgo(version.submitted_at)">
          {{ $t('on') }}
        </span>
        <span>{{ versionDate(version) }}</span>
      </div>
      <div v-if="versionAuthor(version)">
        {{ lightColor ? ', ' : '' }}{{ versionAuthor(version) }}
      </div>
    </div>
  </div>
</template>

<script>
  import prettyDates from '@/utils/formatting/pretty-date';
  import isDateLessThanWeekAgo from '@/utils/formatting/less-than-week-ago';
  import TENDER_OFFER_VERSION_STATUSSES from '@/utils/constants/tender-offer-version-statuses';

  export default {
    name: 'VersionDescription',
    props: {
      version: {
        type: Object,
        required: true,
      },
      lightColor: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return { TENDER_OFFER_VERSION_STATUSSES };
    },
    methods: {
      isDateLessThanWeekAgo,
      getPrettyDate(date) {
        return prettyDates({ start: date, end: date }, false, true);
      },
      versionAuthor(version) {
        return version?.author_user?.name ? `by ${version.author_user.name}` : '';
      },
      versionDate(version) {
        return version.submitted_at ? this.getPrettyDate(version.submitted_at) : '';
      },
    },
  };
</script>
<style scoped lang="scss">
  @import 'src/styles/colors';

  .light-description {
    color: $grey600;
    font-size: 12px;
    white-space: nowrap;
  }
</style>
